import api from './client';

export const registerUser = (data) => api.post('/auth/register', data).then((r) => r.data);
export const loginUser = (credentials) => api.post('/auth/login', credentials).then((r) => r.data);
export const logoutUser = () => api.post('/auth/logout');
export const getCurrentUser = () => api.get('/auth/me').then((r) => r.data);
export const updateUser = (data) => api.put('/auth/me', data).then((r) => r.data);
export const changePassword = (data) => api.post('/auth/change-password', data).then((r) => r.data);
export const forgotPassword = (email) => api.post('/auth/forgot-password', email).then((r) => r.data);
export const resetPassword = (data) => api.post('/auth/reset-password', data).then((r) => r.data);